module.exports = __webpack_public_path__ + "img/arrow-right.cf3fcfc3.svg";